import React from 'react';
import { attributeTypes, Images } from 'utils';
import { ContentSection } from './contentSection';
import { BehaviorSection } from './behaviorSection';
import { writeField } from './writeField';
import { inlineFieldIcon } from '../../formBody/elements/inlineFieldExtension';
import { inlineInputTypes, mapInlineFields, updateInlineField } from '../../../utils/inlineFields';

/** The breadcrumb's name for a field: its kind, as on the Insert row. */
const inlineFieldTypeName = (field) => {
    if (field?.type === attributeTypes.SELECT) return 'Select';
    if (field?.type === attributeTypes.CHECK_BOX) return 'Checkbox';
    if (field?.type === attributeTypes.RADIO_BUTTON) return 'Radio';
    if (field?.defaultDateType === inlineInputTypes.DATE) return 'Date';
    return 'Inputfield';
};

/**
 * Properties of one inline field inside a RICH_TEXT (`utils/inlineFields.js`).
 * The field's config is attribute-shaped, so the regular Content and Behavior
 * sections edit it; each change rewrites that field's span in the text.
 * Conditional Logic and AI Assist are not offered per field.
 *
 * `richText.value` is the html holding the field — a Rich Text attribute's value,
 * or a Goal block's goal / target design (`parentLabel` names it in the breadcrumb).
 */
export const InlineFieldProperties = ({ richText, entry, handleUpdate, onBack, onClose, parentLabel = 'Rich Text' }) => {
    const { id, field } = entry;

    const updateField = (key, value) => {
        const next = writeField(field, key, value);
        // writeField clears `value` for a type switch; a field's value lives on the span, not in its config.
        delete next.value;
        const html = updateInlineField(richText?.value, id, { field: next, value: key === 'defaultDateType' ? '' : undefined });
        handleUpdate('value', html);
    };

    const handleDelete = () => {
        handleUpdate('value', mapInlineFields(richText?.value, (other) => (other.id === id ? '' : undefined)));
        onBack();
    };

    return (
        <div className="properties-wrapper">
            <div className="properties-header">
                <h3>Properties</h3>
                <button className="reset-btn-by-default" onClick={onClose}>
                    <img src={Images.closeSingleVector} alt="close" style={{ width: 18, height: 18 }} />
                </button>
            </div>
            <div className="inline-field-breadcrumb">
                <button type="button" className="inline-field-breadcrumb-back" onClick={onBack}>
                    <img src={Images.arrowRight} alt="" />
                    {parentLabel}
                </button>
                <span className="inline-field-breadcrumb-sep">/</span>
                <img src={inlineFieldIcon(field)} alt="" className="inline-field-breadcrumb-icon" />
                <span className="inline-field-breadcrumb-name">{inlineFieldTypeName(field)}</span>
            </div>
            <div className="properties-divider" />
            {/* Inline fields: an Input stays text (or date) and choices have no minimum. */}
            <ContentSection selectedItem={field} handleUpdate={updateField} inline showType={field?.type === attributeTypes.SELECT} />
            <div className="properties-divider" />
            <BehaviorSection selectedItem={field} handleUpdate={updateField} showMinSelections={false} />
            <div className="properties-divider" />
            <div className="properties-section">
                <div className="section-header">
                    <img src={Images.behaivorIcon} alt="actions" />
                    <span>ACTIONS</span>
                </div>
                <div className="properties-actions-row">
                    <button className="properties-action-btn delete" onClick={handleDelete}>
                        <img src={Images.trash} alt="delete" />
                        <span>Delete</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
